import * as yup from 'yup';

export const uomFormSchema = yup.object().shape({
  uomId: yup.string().nullable(),
  purchaseCostUom: yup.string().nullable(),
  salesUom: yup.string().nullable(),
  packageUom: yup.string().nullable(),
  externalUom: yup.string().nullable(),
});
